<template>
    <v-container style="max-width:100vw;">
        <!--totals/-->
        <!-- Filtros -->
        <v-navigation-drawer style="top: 0px; max-height:100vh!important;" right v-model="filters" :clipped="$vuetify.breakpoint.lgAndUp" app>
            <filterQuotations @filtersCollectionStatus="filtersCollectionStatus"/>
        </v-navigation-drawer>
        <!-- Contenedor show-expand -->
        <div id="tablaPDF">
        <v-data-table 
        :headers="showHeaders"
        :items="records" 
        class="elevation-0 px-6 py-4 collection-status-table"
        fixed-header
        :options.sync="options"
        :loading="loading"
        :hide-default-footer="true"
        group-by="header"
        :items-per-page="999">
            <template v-slot:top>
                <v-toolbar flat class="mb-2">
                    <v-toolbar-title :style="print_view?'font-size:30px;':''">Cobranza por Status</v-toolbar-title>
                    <span v-if="print_view">{{'Actualizado Fecha de Creación: ' + date}}</span>
                    <v-btn v-if="!print_view" icon @click="printDiv">
                        <v-icon>mdi-download</v-icon>
                    </v-btn>
                    <!--v-btn v-if="!print_view" icon @click="openFilter()">
                        <v-badge v-if="filterStorageLength > 0" :content="filterStorageLength" color="primary" overlap>
                            <v-icon>mdi-filter</v-icon>
                        </v-badge>
                        <template v-else>
                            <v-icon>mdi-filter</v-icon>
                        </template>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-select v-if="!print_view" style="max-width:350px!important;" class="mr-4 mt-6" v-model="selectedHeaders" :items="headers" label="Columnas" dense multiple outlined return-object>
                        <template v-slot:prepend-item>
                            <v-list-item ripple @mousedown.prevent @click="toggle">
                            <v-list-item-action>
                                <v-icon :color="selectedHeaders.length > 0 ? 'primary' : ''">
                                {{ icon }}
                                </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                Seleccionar Todo
                                </v-list-item-title>
                            </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                        </template>
                        <template v-slot:selection="{ item, index }">
                            <v-chip color="primary" x-small v-if="index < 2">
                                <span style="font-size:11px;">{{ item.text }}</span>
                            </v-chip>
                            <span v-if="index === 2" style="font-size:10px!important;" class="grey--text caption">(+{{ selectedHeaders.length - 2 }} más)</span>
                        </template>
                    </v-select-->
                </v-toolbar>
            </template>
            <template v-slot:footer>
                <v-row class="ma-0 pb-2 pr-2" :style="print_view?'margin-top:30px;':''">
                    <v-spacer></v-spacer>
                   <strong>{{'Ventas por cobrar real = ' + total.toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</strong>
                </v-row>
            </template>

            <template v-slot:group.header="{ items }">

                <td v-for="(h, index) in headers" :key="index">
                    <strong v-if="h.value=='subtotal'">{{subtotal.toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</strong>
                    <strong v-if="h.value=='total'">{{total.toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</strong>
                    <strong v-if="h.value=='percentage'">{{percentage.toFixed(0) + '%'}}</strong>
                </td>
                
            </template>

            <template v-slot:[`item.status`]="{ item }">
                <v-chip small :color="collection_statuses.filter(c=>c.value == item.status).map(c=>c.chipColor)[0]" :style="'color:' + collection_statuses.filter(c=>c.value == item.status).map(c=>c.textColor)[0] + '!important;'">{{item.status}}</v-chip>
            </template>

            <template v-slot:[`item.description`]="{ item }">
                {{collection_statuses.filter(c=>c.value == item.status).map(c=>c.description)[0]}}
            </template>

            <template v-slot:[`item.subtotal`]="{ item }">
                {{item.subtotal.toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}
            </template>
            <template v-slot:[`item.percentage`]="{ item }">
                {{item.percentage + '%'}}
            </template>
            <template v-slot:[`item.total`]="{ item }">
                {{item.total.toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}
            </template>

            <!-- Tabla sin información -->
            <template v-slot:no-data>
                Sin cobranza a mostrar
            </template>
        </v-data-table>
        </div>
        
        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
    </v-container>
</template>

<script>
    import vueHtml2pdf from 'vue-html2pdf';
    import axios from "axios";
    import Filter from "./filter"
    export default {
        components: {
            'filterQuotations':Filter,
            vueHtml2pdf
        }, 
        data: () => ({
            filterStorageLength:0,
            snackbar: {
                show: false,
                message: null,
                color: null
            },
            filters: false,
            records: [],
            headers:[],
            selectedHeaders: [],
            options: {},
            totalRecords:0,
            loading:false,
            total:0,
            subtotal:0,
            percentage:0,
            print_view:false,
            date:''
        }),
        computed: {
            collection_statuses(){
                return this.$store.state.collection.collection_statuses
            },
            showHeaders () {
                if(this.records!=''){
                    return this.headers.filter(s => this.selectedHeaders.includes(s));
                }
            },
            currentUser(){
                return this.$store.state.currentUser.user;
            },
            headersMap(){ 
                return [
                { text: 'Estatus CRM', value: 'status' },
                { text: 'Subtotal', value: 'subtotal' },
                { text: 'Total (IVA)', value: 'total' },
                { text: '%', value: 'percentage' },
                { text: 'Descripción', value: 'description' },
            ]},
            likesAllFruit () {
                return this.selectedHeaders.length === this.headersMap.length
            },
            likesSomeFruit () {
                return this.selectedHeaders.length > 0 && !this.likesAllFruit
            },
            icon () {
                if (this.likesAllFruit) return 'mdi-close-box'
                if (this.likesSomeFruit) return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            },
        },
        created () {
            this.headers = Object.values(this.headersMap);
            this.selectedHeaders = this.headers;
        },
        watch: {
            options: {
                handler () {
                    if(JSON.stringify(this.currentUser).length>10){
                        this.getDataFromApi()
                    }
                },
                deep: true,
            },
            currentUser: {
                handler () {
                    this.getDataFromApi()
                },
                deep: true,
            },
        },
        methods: {
            printDiv() {
                this.print_view = true
                this.$nextTick(() => {
                    const printContents = document.getElementById("tablaPDF").innerHTML;
                    const printWindow = window.open("", "", "width=1000,height=800");
                    printWindow.document.write(`
                        <html>
                            <head>
                                <title>Imprimir</title>
                                <style>
                                    body {
                                        font-family: Arial, sans-serif;
                                        padding: 20px;
                                    }
                                    table {
                                        width: 100%;
                                        border-collapse: collapse;
                                    }
                                    th, td {
                                        padding: 8px;
                                        border: 1px solid #ccc;
                                        text-align: left;
                                    }
                                </style>
                            </head>
                            <body>
                                ${printContents}
                            </body>
                        </html>
                    `);
                    printWindow.document.close();
                    printWindow.focus();
                    printWindow.onafterprint = () => {
                        printWindow.close();
                    };
                    printWindow.print();
                    this.$nextTick(() => {
                        this.print_view = false;
                    })
                });
            },

            getDataFromApi () {
                this.loading = true
                this.apiCall().then(data => {
                    this.records = data.items
                    this.total = data.totalSum
                    this.subtotal = data.subtotalSum
                    this.percentage = data.percentageSum
                    this.loading = false
                })
            },
            apiCall () {
                return new Promise((resolve, reject) => {
                    this.filterStorageLength = localStorage.getItem('filtersCollectionStatusLength')
                    var link = ''
                    if(localStorage.getItem('filtersCollectionStatus')!=null){
                        link = '?' + JSON.parse(localStorage.getItem('filtersCollectionStatus'))
                    }
                    axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/collection-status-report?filter[pending_sales]=1&" + link).then(response => {
                        this.date = new Date().toLocaleString("es-MX", {
                            timeZone: "America/Monterrey",
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                            hour: "numeric",
                            minute: "2-digit",
                            hour12: true
                        });
                        var items = response.data.map(id=>{return{
                            status:id.collection_status,
                            subtotal:(id.subtotal*1),//.toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}),
                            total:(id.total*1),//.toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}),
                            percentage:id.percentage,// + '%',
                            header:'peach'
                        }})
                        let totalSum = response.data.reduce((acc, id) => acc + (id.total * 1), 0);
                        let subtotalSum = response.data.reduce((acc, id) => acc + (id.subtotal * 1), 0);
                        let percentageSum = response.data.reduce((acc, id) => acc + (id.percentage * 1), 0);
                        resolve({
                            items,
                            totalSum,
                            subtotalSum,
                            percentageSum
                        })
                    })
                })
            },
            toggle () {
                this.$nextTick(() => {
                    if (this.likesAllFruit) {
                        this.selectedHeaders = []
                    } else {
                        this.selectedHeaders = this.headersMap.slice()
                    }
                })
            },
            openFilter(){
                if(this.filters == false){
                    this.$emit("closeDrawer", false);
                    this.filters = true
                }else{
                    this.$emit("closeDrawer", true);
                    this.filters = false
                }
            },
            permissions(permission){
                if(this.currentUser.id==1){
                    return true
                }else if(this.currentUser.permissions!=undefined){
                    if(this.currentUser.permissions.includes(permission)){
                        return true
                    }else{
                        return false
                    }
                }else{
                    return false
                }
            },
            filtersCollectionStatus: function(params) {
                this.getDataFromApi()
            }
        }
    }
</script>
<style>
.collection-status-table .v-toolbar__content{
    padding:0px!important;
}
</style>